export default {
    datasync: {
        que: "Copia grandes volúmenes de datos entre tu red local y AWS (o entre servicios de AWS) de forma rápida, programada y verificada.",
        patron: "lineal",
        nodos: [["Almacenamiento local (NFS/SMB)", "carpeta"], ["Agente DataSync", "engranaje"], ["S3 / EFS / FSx", "nube"]],
        pasos: ["Instalas un agente en tu red que lee los archivos de origen.", "Una tarea transfiere los datos cifrados, con compresión y paralelismo, y verifica la integridad en destino."],
        objetos: {
            "Tareas": ["Define origen, destino, filtros y horario de la copia.", 1],
            "Agentes": ["Máquina virtual que lee tus datos locales y habla con AWS.", 1],
            "Ubicaciones": ["Origen o destino de la copia (NFS, SMB, S3, EFS, FSx).", 0],
        },
    },
    transfer: {
        que: "Servidores SFTP, FTPS y FTP administrados que guardan los archivos directamente en S3 o EFS, para integrarte con socios que usan esos protocolos.",
        patron: "lineal",
        nodos: [["Socio / cliente SFTP", "usuario"], ["Servidor Transfer Family", "servidor"], ["Bucket S3", "carpeta"]],
        pasos: ["El socio se conecta por SFTP con su usuario y su clave.", "Transfer autentica y traduce las operaciones de archivo en objetos de S3 dentro de la carpeta asignada."],
        objetos: {
            "Servidores": ["Punto de conexión SFTP/FTPS/FTP, público o dentro de tu VPC.", 1],
            "Usuarios": ["Identidades con su carpeta raíz y permisos.", 0],
            "Conectores": ["Envían o traen archivos hacia servidores SFTP externos.", 1],
        },
    },
    snow: {
        que: "Dispositivos físicos para mover petabytes a AWS cuando la red es lenta, o para computar en lugares sin conexión.",
        patron: "lineal",
        nodos: [["Tus datos", "datos"], ["Dispositivo Snow", "contenedor"], ["Transporte", "globo"], ["S3 en AWS", "nube"]],
        pasos: ["AWS te envía el dispositivo y copias tus datos.", "Lo devuelves y viaja cifrado hasta AWS.", "AWS descarga el contenido en tu bucket de S3."],
        objetos: {
            "Jobs": ["Pedido de importación o exportación con su seguimiento.", 0],
            "Dispositivos": ["Equipos Snowcone, Snowball o Snowmobile.", 1],
        },
    },
    mgn: {
        que: "Migra servidores físicos o virtuales a EC2 con replicación continua y un corte con muy poca interrupción.",
        patron: "lineal",
        nodos: [["Servidor origen", "servidor"], ["Agente de replicación", "engranaje"], ["Área de preparación", "datos"], ["Instancia EC2 lanzada", "nube"]],
        pasos: ["Instalas un agente en el servidor de origen.", "Los discos se replican de forma continua a un área de preparación en AWS.", "Al lanzar la prueba o el corte, se crea la instancia EC2 con los datos más recientes."],
        objetos: {
            "Servidores origen": ["Los servidores a migrar, con el estado de su replicación.", 0],
            "Lanzamientos": ["Pruebas y cortes que crean las instancias finales.", 3],
        },
    },
    migrationhub: {
        que: "Panel único para planificar y seguir las migraciones: descubre tus servidores, los agrupa en aplicaciones y muestra el avance.",
        patron: "lineal",
        nodos: [["Servidores descubiertos", "servidor"], ["Migration Hub", "grafico"], ["Aplicaciones", "carpeta"], ["Herramientas de migración", "engranaje"]],
        pasos: ["Descubre tus servidores y su uso.", "Los agrupas en aplicaciones para migrarlos juntos.", "Sigue el avance de las herramientas (MGN, DMS) en un único tablero."],
        objetos: {
            "Aplicaciones": ["Grupos de servidores que se migran como una unidad.", 2],
            "Servidores descubiertos": ["Inventario de servidores con sus dependencias y uso.", 0],
        },
    },
};
